import Email from '@/models/Email'
import axios from 'axios'
import { MessageResponse } from './responses'

export interface SubscribeRequest {
  email: string;
}

export default abstract class EmailApi {
  static async getAllEmails () {
    let response = await axios.get<Email[]>('/emails')

    return response.data
  }

  static async subscribe (data: SubscribeRequest) {
    let response = await axios.post<MessageResponse>('/emails/subscribe', data)

    return response.data
  }
}
